document.addEventListener('DOMContentLoaded', () => {
    initializeSearch(document.querySelector('.searchInput'));
});

function initializeSearch(input) {
    const dropdown = document.createElement('div');
    dropdown.className = 'dropdown hidden';
    input.parentElement.appendChild(dropdown); // Add dropdown container after input

    input.addEventListener('input', async function () {
        const query = this.value.trim().toLowerCase();
        dropdown.innerHTML = ''; // Clear previous options
        dropdown.classList.add('hidden'); // Hide dropdown initially

        if (query.length < 3) return; // Start searching only after 3 characters

        try {
            // Fetch products based on the query
            const response = await fetch(`/search/suggest.json?q=${query}`);
            const data = await response.json();

            if (data.resources.results.products.length === 0) {
                dropdown.innerHTML = '<div class="dropdown-item">No products found</div>';
                dropdown.classList.remove('hidden'); // Show dropdown with message
                return;
            }

            // Loop through products and populate dropdown
            data.resources.results.products.forEach(async product => {
                const productDetailsResponse = await fetch(`/products/${product.handle}.json`);
                const productDetails = await productDetailsResponse.json();

                const variants = productDetails.product.variants;
                if (variants.length > 0) {
                    variants.forEach(variant => {
                        const item = document.createElement('div');
                        item.className = 'dropdown-item';
                        item.innerHTML = `
                            <img src="${product.featured_image?.url || 'https://via.placeholder.com/50'}" alt="Product Image">
                            <span>${product.title})</span>
                        `;
                        item.addEventListener('click', () => {
                            const row = input.closest('tr');
                            populateRowWithVariant(row, { ...product, variant });
                            dropdown.classList.add('hidden'); // Hide dropdown after selection
                        });
                        dropdown.appendChild(item);
                    });
                } else {
                    const item = document.createElement('div');
                    item.className = 'dropdown-item';
                    item.innerHTML = `
                        <img src="${product.featured_image?.url || 'https://via.placeholder.com/50'}" alt="Product Image">
                        <span>${product.title}</span>
                    `;
                    item.addEventListener('click', () => {
                        const row = input.closest('tr');
                        populateRowWithVariant(row, product);
                        dropdown.classList.add('hidden'); // Hide dropdown after selection
                    });
                    dropdown.appendChild(item);
                }
            });

            dropdown.classList.remove('hidden'); // Show dropdown after populating
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    });

    // Hide dropdown if clicked outside
    document.addEventListener('click', (event) => {
        if (!dropdown.contains(event.target) && event.target !== input) {
            dropdown.classList.add('hidden');
        }
    });
}

function populateRowWithVariant(row, product) {
  console.log('product1', product);
    if (!row) {
        console.error('Row does not exist. Cannot populate data.');
        return;
    }

    const sku = row.querySelector('td:nth-child(1)');
    const img = row.querySelector('td:nth-child(2) img');
    const productName = row.querySelector('td:nth-child(3)');
    const price = row.querySelector('td:nth-child(5)');
    const stockInfo = row.querySelector('td:nth-child(6)');

    sku.textContent = product.variant?.sku || 'N/A';
    img.src = product.featured_image?.url || 'https://via.placeholder.com/50';
    productName.textContent = product.title;
    price.textContent = `Rs ${product.price}`;
    stockInfo.textContent = product.available ? 'In Stock' : 'Out of Stock'; 

    row.dataset.productId = product.id;
    row.dataset.variantId = product.variant?.id || '';
}

    document.getElementById('addNewRowButton').addEventListener('click', function () {
        const tbody = document.querySelector('#productTable tbody');

        const newRow = document.createElement('tr');
        newRow.innerHTML = `
            <td>
                <input type="text" class="form-control searchInput" placeholder="Enter product name">
                <select class="searchSelect hidden"></select>
            </td>
            <td><img src="https://via.placeholder.com/50" alt="No Image" style="width: 50px;"></td>
            <td></td>
            <td>
              <div class="QtyWrapper">
                <button onclick="updateQty(this, -1)">-</button>
                <span>1</span>
                <button onclick="updateQty(this, 1)">+</button>
              </div>
            </td>
            <td class="price"></td>
            <td class="stock-count"></td>
            <td>
                <button onclick="removeItem(this)"><img src="https://zapdent.myshopify.com/cdn/shop/t/5/assets/delete.svg" height="30px" width="30px"></button>
            </td>
        `;
        tbody.appendChild(newRow);
        initializeSearch(newRow.querySelector('.searchInput'));
    });

    function updateQty(button, change) {
        const qtySpan = button.parentElement.querySelector('span');
        let currentQty = parseInt(qtySpan.innerText);
        currentQty += change;
        if (currentQty >= 0) {
            qtySpan.innerText = currentQty;
        }
    }

    function removeItem(button) {
        const row = button.closest('tr');
        row.parentElement.removeChild(row);
    }


function bulkAddToCart() {
    const rows = document.querySelectorAll('#productTable tbody tr');
    const items = [];

    rows.forEach(row => {
        const variantId = row.dataset.variantId; // Retrieve variantId from the row dataset
        const quantity = parseInt(row.querySelector('span').innerText.trim());

        if (variantId && quantity > 0) {
            items.push({ id: parseInt(variantId), quantity }); // Push variantId and quantity
        }
    });

    if (items.length === 0) {
        alert('No valid products to add to the cart.');
        return;
    }

    console.log('Items to be added:', items);

    Shopify.KT_addItems(items, function () {
        showPopup(items.length); // Show popup with the number of products added
    });
}

function showPopup(productCount) {
    // Create popup container
    const popup = document.createElement('div');
    popup.className = 'popup-container';
    popup.innerHTML = `
        <div class="popup-content">
            <img src="https://zapdent.myshopify.com/cdn/shop/t/5/assets/shopping_bag_speed.png" height="50px" width="50px" alt="Success Icon" class="popup-icon" />
            <p>${productCount} Products added to cart Successfully</p>
            <button class="popup-button" onclick="window.location.href='/cart'"><img src="https://zapdent.myshopify.com/cdn/shop/t/5/assets/add_shopping_cart.png" alt="add to cart icon" />Go to Cart</button>
        </div>
    `;

    // Style the popup
    const style = document.createElement('style');
    style.textContent = `
        .popup-container {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
        }
        .popup-content {
            background: white;
            padding: 10px 100px;
            border-radius: 10px;
            text-align: center;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
            line-height: 10em;
        }
        .popup-container .popup-content p {
            color: #5A5A5A;
            font-size: 32px;
            line-height: 39px;
        }
        .popup-icon {
            width: 50px;
            margin-bottom: 10px;
        }
        .popup-button {
            background: #007bff;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 5px;
            cursor: pointer;
            margin-top: 10px;
            font-size: 20px;
        }
        .popup-button:hover {
            background: #0056b3;
        }
    `;

    // Append popup and style to the body
    document.body.appendChild(popup);
    document.head.appendChild(style);

    // Close popup after 5 seconds
    // setTimeout(() => {
    //     document.body.removeChild(popup);
    // }, 5000);
}

// Attach event listener to bulk add button
document.getElementById('bulkAddButton').addEventListener('click', bulkAddToCart);


   // function bulkAddToCart() {
   //    const rows = document.querySelectorAll('#productTable tbody tr');
   //    const items = [];
  
   //    rows.forEach(row => {
   //        const variantId = row.dataset.variantId; // Retrieve variantId from the row dataset
   //        const quantity = parseInt(row.querySelector('span').innerText.trim());
  
   //        if (variantId && quantity > 0) {
   //            items.push({ id: parseInt(variantId), quantity }); // Push variantId and quantity
   //        }
   //    });
  
   //    if (items.length === 0) {
   //        alert('No valid products to add to the cart.');
   //        return;
   //    }
  
   //    console.log('Items to be added:', items);
  
   //    Shopify.KT_addItems(items, function () {
   //        const userChoice = confirm('All products added to the cart successfully!');
   //        if (userChoice) {
   //            // Redirect to the cart page if "OK" is clicked
   //            window.location.href = '/cart';
   //        } else {
   //            // Reload the page if "Cancel" is clicked
   //            window.location.reload();
   //        }
   //    });

   //  }

  document.getElementById('bulkAddButton').addEventListener('click', bulkAddToCart);

  Shopify.KT_addItems = function(items, callback) {
      var ajax = {
          type: "POST",
          url: "https://zapdent.myshopify.com/cart/add.js",
          data: JSON.stringify({ 'items': items }),
          dataType: "json",
          contentType: "application/json",
          success: function(data) {
              if (typeof callback === "function") {
                  callback(data);
              } else {
                  console.log('Items added successfully:', data);
              }
          },
          error: function(xhr, textStatus, errorThrown) {
              console.error('Error adding items to cart:', xhr.responseText || textStatus);
              alert(`Failed to add items. ${xhr.responseText || textStatus}`);
          }
      };
      jQuery.ajax(ajax);
  };


    Shopify.KT_onError = function(data, textStatus) {
        console.error('Error adding items to cart:', data, textStatus);
        alert('There was an error adding items to the cart. Please try again.');
    }; 
